import { DocumentNode } from 'graphql';
import {
  gql, QueryHookOptions, useLazyQuery, useQuery,
} from '@apollo/client';
import { IOrderAskForQuoteSchemaPartial, IOrderAskForQuoteSchema } from '../../type/orderAskForQuote';
import { IWithPagination, DeepPartial } from '../_module/baseQueryType';



export interface IOrderAskForQuoteVars {
  
 filter: {
  _id?: string;
  _ids?: string[];
  buyerUserId?: string;
  buyerCompanyId?: string;
  sellerCompanyId?: string;
  isSellerArchive?: boolean;
  isBuyerArchive?: boolean;
  isUnseen?: boolean;
  buyerCompanyIdNotExists?: boolean;
}
 sort: {
  _id?: number;
  updatedTime?: number;
  createdTime?: number;
}
 search: {
  _id?: string;
  buyerName?: string;
  buyerCompanyName?: string;
  sellerName?: string;
  sellerCompanyName?: string;
}
 skip?: number
 limit?: number
 
  
  
  
  
 
}
export const OrderAskForQuoteQueryTypeDefinitionKey = 'OrderAskForQuote';
export type IOrderAskForQuoteVarsPartial = Partial<IOrderAskForQuoteVars>
export type IOrderAskForQuoteDataPartial = DeepPartial<IOrderAskForQuoteSchemaPartial>
export interface IOrderAskForQuoteQueryData<TData extends IOrderAskForQuoteSchema = IOrderAskForQuoteSchema>{
  

    orderAskForQuotes: IWithPagination<TData>
}

export function orderAskForQuoteQuery(fragment: string, rootFragment?: string, withPagination?: boolean): DocumentNode {
  return gql`
        query 

    orderAskForQuotes(
        $filter: OrderAskForQuoteQueryFilterParameterInput,
$search: OrderAskForQuoteQuerySearchParameterInput,
$sort: OrderAskForQuoteQuerySortParameterInput,
$skip: Int,
$limit: Int
        ){
        

    orderAskForQuotes(
        filter: $filter,
search: $search,
sort: $sort,
skip: $skip,
limit: $limit
        ){
          items {
              ${fragment}
          }
          ${withPagination ? `
          pagination {
            total
            perPage
            currentPage
            hasNextPage
            totalPage
          }
          ` : ''}
          ${rootFragment || ''}
        }
        }
    `;
}

export function useOrderAskForQuoteLazyQuery<TData extends IOrderAskForQuoteSchema>(
  fragment: string,
  options?: QueryHookOptions<IOrderAskForQuoteQueryData<TData>, IOrderAskForQuoteVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useLazyQuery<IOrderAskForQuoteQueryData<TData>, IOrderAskForQuoteVarsPartial>(orderAskForQuoteQuery(fragment, rootFragment, withPagination), options);
}

export function useOrderAskForQuoteQuery<TData extends IOrderAskForQuoteSchema>(
  fragment: string,
  options?: QueryHookOptions<IOrderAskForQuoteQueryData<TData>, IOrderAskForQuoteVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useQuery<IOrderAskForQuoteQueryData<TData>, IOrderAskForQuoteVarsPartial>(orderAskForQuoteQuery(fragment, rootFragment, withPagination), options);
}
